import React from "react";
import { motion } from "framer-motion";


const cardVariants = {
  hidden: { opacity: 0, y: 40, scale: 0.98 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      delay: i * 0.18 + 0.3,
      type: "spring",
      stiffness: 80,
      damping: 14,
    },
  }),
};

export default function ContactUs() {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      {/* Top Banner */}
      <motion.section
        className="relative h-48 sm:h-64 md:h-80 lg:h-96 bg-cover bg-center"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/contact.jpg)`,
        }}
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <div className="absolute inset-0 bg-blue-900 bg-opacity-75"></div>
        <h1 className="relative z-10 text-white text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-center pt-16 sm:pt-20 md:pt-24 lg:pt-32">
          Contact Us
        </h1>
      </motion.section>

      {/* Form + Info Cards */}
      <section className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-20 py-10 sm:py-14 lg:py-18 space-y-12 w-full">
        {/* Contact Form */}
        <motion.div
          initial={{ opacity: 0, scale: 0.97, y: 24 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, type: "spring" }}
          viewport={{ once: true }}
          className="bg-white p-6 sm:p-8 md:p-12 rounded-2xl shadow-2xl w-full max-w-3xl mx-auto"
        >
          <form
            action="https://formsubmit.co/info@falconlawoffice.ca"
            method="POST"
          >
            <input type="hidden" name="_next" value="https://falconlawoffice.ca/thank-you" />
            <input type="hidden" name="_captcha" value="false" />

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-gray-700 font-medium mb-2 text-lg">
                  Your Name*
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="e.g. John Doe"
                  required
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-gray-700 font-medium mb-2 text-lg">
                  Your Email*
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="email@example.com"
                  required
                  className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
                />
              </div>
            </div>

            <div className="mt-5">
              <label htmlFor="phone" className="block text-gray-700 font-medium mb-2 text-lg">
                Your Phone Number*
              </label>
              <input
                type="tel"
                id="phone"
                name="phone"
                placeholder="+1 (403) 603-0447"
                required
                className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
              />
            </div>

            <div className="mt-5">
              <label htmlFor="inquiryType" className="block text-gray-700 font-medium mb-2 text-lg">
                Reason for Contact*
              </label>
              <select
                id="inquiryType"
                name="inquiryType"
                required
                className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
              >
                <option value="">— Please choose an option —</option>
                <option value="Family Law">Family Law</option>
                <option value="Immigration Law">Immigration Law</option>
                <option value="Real Estate">Real Estate</option>
                <option value="Wills and Estate">Wills and Estate</option>
                <option value="Civil Litigation">Civil Litigation</option>
                <option value="Personal Injury">Personal Injury</option>
                <option value="Employment Law">Employment Law</option>
                <option value="Administrative Law">Commercial Law</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="mt-5">
              <label htmlFor="message" className="block text-gray-700 font-medium mb-2 text-lg">
                How Can We Help?*
              </label>
              <textarea
                id="message"
                name="message"
                rows={5}
                placeholder="Describe your inquiry here..."
                required
                className="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-lg"
              ></textarea>
            </div>

            <div className="text-center mt-8">
              <motion.button
                type="submit"
                className="bg-blue-900 text-white px-8 py-3 rounded-md font-semibold hover:bg-blue-800 transition"
                whileHover={{
                  scale: 1.06,
                  boxShadow: "0px 4px 28px 0px rgba(30,64,175,0.18)",
                }}
                transition={{ type: "spring", stiffness: 220 }}
              >
                Submit 
              </motion.button>
            </div>
          </form>
        </motion.div>

        {/* Info Cards with Animation */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {[
            {
              img: "phone.png",
              alt: "Contact Icon",
              heading: "Contact Us",
              content: (
                <>
                  <p>
                    <span className="font-semibold">Phone:</span>{" "}
                    <a
                      href="tel:(587) 971-0447"
                      className="text-blue-600 hover:underline break-all"
                    >
                      (587) 971-0447
                    </a>
                  </p>

                  <p>
  <span className="font-semibold">Fax:</span>{" "}
  <span className="text-blue-600 break-all">(587) 791-1838</span>
</p>
                  <p>
                    <span className="font-semibold">Email:</span>{" "}
                    <a
                      href="mailto:info@falconlawoffice.com"
                      className="text-blue-600 hover:underline break-all"
                    >
                      info@falconlawoffice.ca
                    </a>
                  </p>
                </>
              ),
            },
            {
              img: "maps.png",
              alt: "Address Icon",
              heading: "Our Address",
              content: (
                <>
                  <p>
                    Suite 290, 6815 - 8th Street NE
                    <br />
                    Calgary, Alberta T2E 7H7
                    <br />
                    Canada
                  </p>
                  <p>
                    <a
                      href="https://maps.app.goo.gl/uHDtyUVqyP3WBN188"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block mt-2 text-blue-600 hover:underline"
                    >
                      Get Directions →
                    </a>
                  </p>
                </>
              ),
            },
            {
              img: "time.png",
              alt: "Hours Icon",
              heading: "Working Hours",
              content: (
                <>
                  <p>Monday – Friday</p>
                  <p>8:30 AM – 4:30 PM</p>
                 
                </>
              ),
            },
          ].map((card, i) => (
            <motion.div
              key={i}
              className="flex flex-col items-center text-center p-6 border rounded-xl shadow-sm bg-white"
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              variants={cardVariants}
            >
              <motion.img
                src={`${process.env.PUBLIC_URL}/images/${card.img}`}
                alt={card.alt}
                className="h-12 w-12 sm:h-14 sm:w-14 mb-4"
                whileHover={{ scale: 1.15, rotate: 5 }}
                transition={{ type: "spring", stiffness: 240 }}
              />
              <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
                {card.heading}
              </h2>
              <div className="text-gray-700 space-y-1 text-base sm:text-lg">{card.content}</div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Full-Width Google Map, flush with footer */}
      <div className="w-screen relative left-1/2 right-1/2 -mx-[50vw] overflow-hidden z-10" style={{ maxWidth: '100vw' }}>
        <iframe
          title="Falcon Law Office Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2504.698035525074!2d-114.04792422329461!3d51.11403127172648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53716505ec12a779%3A0x4e3a69309e005449!2sFalcon%20Law!5e0!3m2!1sen!2sin!4v1753976884402!5m2!1sen!2sin"
          width="100%"
          height="420"
          style={{ border: 0, display: 'block' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}
